<kros-schema-root-outlet [state]="state()" />

<!-- TODO: temporarily commented out - was causing duplicate detail rendering in grid submodules
     (my-documents, invoices, ...) which have their own <router-outlet> inside the grid container.
     Originally added in PR 60112 with the note "will be changed in the future". -->
<!-- <router-outlet /> -->
